// src/hooks/useInsights.js
import { useQuery } from "@tanstack/react-query";
import drEasyApi from "../Api/Customapi";

const useInsights = () => {
  return useQuery({
    queryKey: ["dashboard-insights"],
    queryFn: async () => {
      try {
        const response = await drEasyApi.get("/api/Centers/getInsights");
        return response.data;
      } catch (err) {
        // if (err.response.status == 403) {
        //   window.location.href = "/sub";
        // }
      }
    },
    staleTime: 1000 * 60 * 3,
    refetchOnWindowFocus: true,
    refetchInterval: 1000 * 60 * 5,
  });
};

export default useInsights;

// ─── Clinic Statistics (performance table) ────────────────────────────────────
// GET /api/Statistics/ClinicsPerformace
// Returns: { from, to, clinics: [{ clinicId, clinicName, numOfBookings,
//            completedBookings, numOfSessions, completedSessions }] }
export const useClinicStatistics = (from = null, to = null) => {
  return useQuery({
    queryKey: ["clinic-statistics", from, to],
    queryFn: async () => {
      const params = {};
      if (from) params.From = from;
      if (to) params.To = to;

      const response = await drEasyApi.get("/api/Statistics/ClinicsPerformace", { params });
      // Normalize: the API uses `numOfSessions` but the table column reads `totalSessions`
      const clinics = (response.data?.clinics ?? []).map((c) => ({
        ...c,
        totalSessions: c.numOfSessions ?? 0,
      }));
      return { ...response.data, clinics };
    },
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });
};

// ─── Financial Summary ────────────────────────────────────────────────────────
// GET /api/Statistics/ClinicsEarning
// Returns: { from, to, clinics: [{ clinicId, clinicName, expectedEarnings,
//            actualPaidAmount, remainingAmount }] }
export const useFinancialSummary = (from = null, to = null) => {
  return useQuery({
    queryKey: ["financial-summary", from, to],
    queryFn: async () => {
      const params = {};
      if (from) params.From = from;
      if (to) params.To = to;

      const response = await drEasyApi.get("/api/Statistics/ClinicsEarning", { params });
      return response.data;
    },
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });
};

// ─── Doctors / Consultants Performance ───────────────────────────────────────
// GET /api/Statistics/DoctorsPerformace
// Returns: { from, to,
//   doctors: [{ doctorId, doctorName, totalBookings, completedBookings,
//               cancelledBookings, pendingBookings, skippedBookings, completionRate }],
//   summary: { totalDoctors, totalBookings, totalCancelledBookings,
//              totalCompletedBookings, totalPendingBookings,
//              totalSkippedBookings, overallCompletionRate } }
export const useDoctorsPerformance = (from = null, to = null, doctorId = null) => {
  return useQuery({
    queryKey: ["doctors-performance", from, to, doctorId],
    queryFn: async () => {
      const params = {};
      if (from) params.From = from;
      if (to) params.To = to;
      if (doctorId) params.DoctorId = doctorId;

      const response = await drEasyApi.get("/api/Statistics/DoctorsPerformace", { params });
      return response.data;
    },
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });
};

// ─── Specialists Performance ──────────────────────────────────────────────────
// GET /api/Statistics/SpecilistsPerformace
// Returns: { from, to,
//   specialists: [{ specialistId, specialistName, totalSessions, completedSessions,
//                   cancelledSessions, pendingSessions, skippedSessions, completionRate }],
//   summary: { totalSpecialists, totalSessions, totalCancelledSessions,
//              totalCompletedSessions, totalPendingSessions,
//              totalSkippedSessions, overallCompletionRate } }
export const useSpecialistsPerformance = (from = null, to = null, specialistId = null) => {
  return useQuery({
    queryKey: ["specialists-performance", from, to, specialistId],
    queryFn: async () => {
      const params = {};
      if (from) params.From = from;
      if (to) params.To = to;
      if (specialistId) params.SpecialistId = specialistId;

      const response = await drEasyApi.get("/api/Statistics/SpecilistsPerformace", { params });
      return response.data;
    },
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: true,
  });
};

export const useCancellations=({Search,Type,StatusFilter,PageNumber,PageSize})=>{

   return useQuery({
    queryKey:["cancellations",Search,Type,StatusFilter,PageNumber,PageSize],
    queryFn:async()=>{
      const params={Search,Type,StatusFilter,PageNumber,PageSize}
      
      const response= await drEasyApi.get("/api/Statistics/cancellations",{params})
      return response.data
    },
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: true,

   })
}